import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Button, Form } from 'antd';
import { LinkOutlined, UploadOutlined, AudioOutlined } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import { useSession } from 'components/Authenticated';
import styles from './style.module.less';
const SourceSelect = ({ selectedSource, setSelectedSource, emptyOriginsList, fileDiarizationDefault, filePpcDefault, }) => {
    const { session } = useSession();
    const form = Form.useFormInstance();
    const transcriptionSources = () => {
        const sources = ['file'];
        if (session.login.hasClaim('services:link')) {
            sources.push('link');
        }
        if (session.login.hasClaim('micTranscription:enabled')) {
            sources.push('mic');
        }
        return sources;
    };
    return (_jsx(Flex, { className: styles.tiles, children: transcriptionSources().length > 1 ? (transcriptionSources().map((src) => {
            return (_jsxs(Button, { type: "text", className: `${styles.tile} ${selectedSource === src ? styles.active : ''}`, onClick: () => {
                    setSelectedSource(src);
                    form.setFieldValue('projectName', src === 'mic' ? txt('micRecordingName') : null);
                    form.setFieldValue('originsList', emptyOriginsList);
                    form.setFieldValue('useDiarization', src === 'mic' ? false : fileDiarizationDefault);
                    form.setFieldValue('usePPC', src === 'mic' ? true : filePpcDefault);
                }, children: [src === 'file' && (_jsxs("div", { className: styles.tileContent, children: [_jsx(UploadOutlined, { className: styles.icon }), _jsx("p", { className: styles.tileText, children: txt('uploadFile') })] })), src === 'link' && (_jsxs("div", { className: styles.tileContent, children: [_jsx(LinkOutlined, { className: styles.icon }), _jsx("p", { className: styles.tileText, children: txt('uploadFromURL') })] })), src === 'mic' && (_jsxs("div", { className: styles.tileContent, children: [_jsx(AudioOutlined, { className: styles.icon }), _jsx("p", { className: styles.tileText, children: txt('uploadFromMic') })] }))] }, src));
        })) : null }));
};
export default SourceSelect;
